/* TheraWell theme — minimal interactivity */
(function () {
  "use strict";

  /* Mobile nav toggle */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-nav-toggle]");
    if (toggle) {
      var nav = document.querySelector("[data-mobile-nav]");
      if (nav) nav.classList.toggle("is-open");
    }
  });

  /* Footer: clicking the page you're already on scrolls to top */
  document.addEventListener("click", function (e) {
    var link = e.target.closest("[data-same-page-scroll]");
    if (!link) return;
    var href = link.getAttribute("href");
    if (href && href.split("?")[0].split("#")[0] === window.location.pathname) {
      e.preventDefault();
      window.scrollTo(0, 0);
    }
  });
})();
